import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function RejectRequestDialog({ open, onOpenChange, request, onRejected }) {
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => { if (open) setNote(""); }, [open]);

  const submit = async () => {
    const n = note.trim();
    if (!n) { toast.error("Please add a rejection note"); return; }
    setSubmitting(true);
    try {
      await api.post(`/approvals/${request.id}/reject`, { note: n });
      toast.success("Request rejected");
      onRejected?.();
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Reject failed");
    } finally { setSubmitting(false); }
  };

  if (!request) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="reject-request-dialog">
        <DialogHeader>
          <DialogTitle>Reject payment request</DialogTitle>
          <DialogDescription>
            @{request.creator_username_snapshot} · {request.payment_type}. The executive will see your note as an in-app notification. The request will be voided — a fresh one must be raised.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label className="text-xs uppercase tracking-wider text-slate-500">Rejection note *</Label>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={4}
            placeholder="Explain why — invoice missing, amount mismatch, etc."
            className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2 text-sm"
            data-testid="reject-note"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="reject-cancel">Cancel</Button>
          <Button onClick={submit} disabled={submitting || !note.trim()} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="reject-confirm">
            {submitting ? "Rejecting…" : "Reject request"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
